import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/home/zdobywaj-klientow.png'
import _imports_1 from '@/assets/images/home/specjalisci.png'


const _hoisted_1 = { class: "home-search" }
const _hoisted_2 = { class: "bg-intro" }
const _hoisted_3 = { class: "search-form" }
const _hoisted_4 = { class: "form" }
const _hoisted_5 = { class: "grid" }
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = { class: "grid" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "container bg-width section-home" }
const _hoisted_11 = { class: "home-categories-grid" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "image" }
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "name" }
const _hoisted_16 = {
  class: "container bg-width",
  style: {"padding-bottom":"1px","border-radius":"5px"}
}
const _hoisted_17 = { class: "home-premium-specialists" }
const _hoisted_18 = {
  class: "premium-btn-wrapper",
  style: {"margin-top":"40px"}
}
const _hoisted_19 = { class: "container bg-width section-home-call-to-action" }
const _hoisted_20 = { class: "grid" }
const _hoisted_21 = { class: "grid mt-4" }

import { ref, onMounted, onUnmounted } from 'vue';
import axiosInstance from "@/api/axios";
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation, Autoplay } from 'swiper/modules';
import SingleSpecialist from '@/components/specialists/SingleSpecialist.vue';
import {useRouter} from "vue-router";


export default {
  __name: 'Index',
  setup(__props) {

const categories = ref([]);
const categoriesSwiper = ref(null);
const router = useRouter();

const loadCategories = async () => {
    try {
        const url = `categories?where[is_only_parent]=true&is_pagination=false`;
        const response = await axiosInstance.get(url);
        if (response.status === 200) {
            categories.value = response.data.data;
        }
    } catch (error) {
        console.log(error);
    }
}

const premiumSpecialists = ref([]);
const loadPremiumSpecialists = async () => {
    try {
        const url = `specialists?limit=6&where[is_pro]=1`;
        const response = await axiosInstance.get(url);
        if (response.status === 200) {
            premiumSpecialists.value = response.data.data;
        }
    } catch (error) {
        console.log(error);
    }
}

// Responsive col-12/col-6 for call-to-action
const isMobile = ref(window.innerWidth <= 768);
const handleResize = () => {
    isMobile.value = window.innerWidth <= 768;
};
onMounted(() => {
    loadCategories();
    loadPremiumSpecialists();
    window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
});

const filters = ref({
    service: '',
    lat: '',
    lng: '',
    localization: ''
});

const suggestions = ref([]);

const search = async (event) => {
    if (!event.query || event.query.length < 2) {
        suggestions.value = [];
        return;
    }

    try {
        const response = await axiosInstance.get(`/f/services/names?search=${encodeURIComponent(event.query)}`);
        if (response.status === 200) {
            if (response.data.success === 1) {
                suggestions.value = response.data.data;
            } else {
                suggestions.value = [];
            }
        }
    } catch (error) {
        console.log(error);
        suggestions.value = [];
    }
}

const setPlace = async (e) => {
    filters.value.lat = e.geometry.location.lat();
    filters.value.lng = e.geometry.location.lng();
    filters.value.localization = e.formatted_address;
}

const searchResult = async () => {
    await router.push({
        name: 'Specialists',
        query: {
            lat: filters.value.lat,
            lng: filters.value.lng,
            service: filters.value.service,
            localization: filters.value.localization
        }
    })
}

return (_ctx, _cache) => {
  const _component_InputIcon = _resolveComponent("InputIcon")
  const _component_AutoComplete = _resolveComponent("AutoComplete")
  const _component_IconField = _resolveComponent("IconField")
  const _component_GMapAutocomplete = _resolveComponent("GMapAutocomplete")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("h1", null, "Zarezerwuj wizytę online", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_IconField, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputIcon, { class: "pi pi-search" }),
                    _createVNode(_component_AutoComplete, {
                      modelValue: filters.value.service,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((filters.value.service) = $event)),
                      class: "w-full",
                      placeholder: "Specjalista lub usługa",
                      suggestions: suggestions.value,
                      onComplete: search
                    }, null, 8, ["modelValue", "suggestions"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_GMapAutocomplete, {
                  class: "p-inputtext p-component p-autocomplete-input",
                  id: "localization",
                  placeholder: filters.value.localization || 'Lokalizacja',
                  onPlace_changed: setPlace
                }, null, 8, ["placeholder"])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Button, {
                  onClick: searchResult,
                  type: "button",
                  label: "Szukaj"
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value.slice(0, 10), (category, inx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: inx,
              class: "home-category-item",
              onClick: $event => (_ctx.$router.push({name: 'Specialists', query: {categoryId: category.id}}))
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("img", {
                  width: "50",
                  height: "50",
                  src: category.icon_path,
                  alt: category.name
                }, null, 8, _hoisted_14)
              ]),
              _createElementVNode("div", _hoisted_15, _toDisplayString(category.name), 1)
            ], 8, _hoisted_12))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _cache[4] || (_cache[4] = _createElementVNode("button", { class: "custom-swiper-button-prev" }, [
            _createElementVNode("i", { class: "pi pi-angle-left" })
          ], -1)),
          _cache[5] || (_cache[5] = _createElementVNode("button", { class: "custom-swiper-button-next" }, [
            _createElementVNode("i", { class: "pi pi-angle-right" })
          ], -1)),
          (premiumSpecialists.value.length > 0)
            ? (_openBlock(), _createBlock(_unref(Swiper), {
                key: 0,
                modules: [_unref(Navigation), _unref(Autoplay)],
                "slides-per-view": 1,
                "space-between": 20,
                breakpoints: {640: { slidesPerView: 1 }, 768: { slidesPerView: 2 }, 1024: { slidesPerView: 3 }},
                navigation: {
                        nextEl: '.custom-swiper-button-next',
                        prevEl: '.custom-swiper-button-prev',
                    },
                loop: true,
                observer: true,
                "observe-parents": true,
                autoplay: { delay: 4000, disableOnInteraction: false },
                style: {"padding-top":"30px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(premiumSpecialists.value, (specialist, inx) => {
                    return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: inx }, {
                      default: _withCtx(() => [
                        _createVNode(SingleSpecialist, { item: specialist }, null, 8, ["item"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modules"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_Button, {
              label: "Zobacz wszystkich",
              class: "see-all-btn",
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.$router.push({name: 'Specialists'})))
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", {
            class: _normalizeClass([isMobile.value ? 'col-12' : 'col-6', 'section-text'])
          }, [
            _cache[6] || (_cache[6] = _createElementVNode("h3", null, " Masz firmę usługową? Dołącz do rezerwujwizyty.pl i zdobywaj klientów. ", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("p", null, " Twój czas jest cenny – dlatego stworzyliśmy platformę, która pomaga Ci go zaoszczędzić. ", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("p", null, " Dzięki rezerwujwizyty.pl klienci znajdą Cię sami, zarezerwują wizytę online, a Ty zyskasz spokój, porządek w kalendarzu i więcej czasu na to, co naprawdę ważne – Twoją pracę. ", -1)),
            _createVNode(_component_Button, {
              onClick: _cache[2] || (_cache[2] = $event => (_ctx.$router.push('/register?type=specialist'))),
              label: "Dodaj swój biznes"
            })
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass([isMobile.value ? 'col-12' : 'col-6', 'text-center'])
          }, _cache[9] || (_cache[9] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: ""
            }, null, -1)
          ]), 2)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", {
            class: _normalizeClass([isMobile.value ? 'col-12' : 'col-6', 'text-center'])
          }, _cache[10] || (_cache[10] = [
            _createElementVNode("img", {
              src: _imports_1,
              alt: ""
            }, null, -1)
          ]), 2),
          _createElementVNode("div", {
            class: _normalizeClass([isMobile.value ? 'col-12' : 'col-6', 'section-text'])
          }, _cache[11] || (_cache[11] = [
            _createElementVNode("h3", null, " Wszyscy specjaliści w jednym miejscu - zadbaj o siebie i swoje sprawy, umów termin już teraz ", -1),
            _createElementVNode("p", null, " Szukasz lekarza, kosmetyczki, mechanika lub trenera personalnego? ", -1),
            _createElementVNode("p", null, " Nasza platforma łączy specjalistów z różnych dziedzin w jednym, wygodnym miejscu. Bez względu na to, czy potrzebujesz konsultacji medycznej, wizyty u kosmetyczki, naprawy samochodu czy indywidualnego planu treningowego – u nas szybko znajdziesz odpowiedniego fachowca ", -1),
            _createElementVNode("p", null, " Przeglądaj profile, sprawdzaj opinie i umawiaj wizyty bez zbędnych formalności. Zadbaj o zdrowie, wygląd, auto i kondycję z pomocą sprawdzonych specjalistów z Twojej okolicy. ", -1)
          ]), 2)
        ])
      ])
    ])
  ], 64))
}
}

}